import axios from 'lib/axios'

const baseUrl = `${process.env.REACT_APP_MAIN_API}/person/user/document`

interface Iprops {
  document: string
  personId: number
}

const validateDocument = async (props: Iprops) => {
  const { document, personId } = props
  const headers = {
    'Content-Type': 'application/json',
  }

  const body = {
    document,
    personId,
  }

  const res = await axios
    .post(baseUrl, body, { headers })
    .then((response) => {
      return { data: response.data, status: response.status }
    })
    .catch((error) => {
      console.error('error on validating document', error)
      return { ok: false, message: error.message }
    })
  return res
}

export default validateDocument
